import * as React from 'react';
import { Icon, Path } from './Dropdown.style';
var ChevronDownIcon = _ref => {
  var {
    isDisabled = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    role: "img",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement(Path, {
    isDisabled: isDisabled,
    d: "M8 10L12 14L16 10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { ChevronDownIcon };
//# sourceMappingURL=ChevronDownIcon.js.map